import { initializeAgendaMailOption, AgendaMailOption } from 'owa-agenda-mail-option';
import { OptionSubCategory } from 'owa-options-core';

/**
 * Automatic processing subcategory settings
 */
let agendaMailSubCategory: OptionSubCategory = {
    key: 'agendaMail',
    titleStringKey: 'optionSubcategory_agendaMail',
    options: [AgendaMailOption],
    onSelected: () => {
        initializeAgendaMailOption();
        return Promise.resolve(true);
    },
};

export default agendaMailSubCategory;
